import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import toast from './modules/toast'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',

  state: {
    modals: {
      modalEurope: false,
      modalBusiness: false,
      modalWorld: false,
    },
  },
  getters: {
    modals: state => state.modals,
    hasVisibleModal: state =>
      Object.keys(state.modals).some(modal => state.modals[modal]),
  },
  mutations: {
    modal(state, { modal, visible }) {
      state.modals[modal] = visible
    },
  },
  modules: {
    auth: {
      namespaced: true,
      ...auth,
    },
    toast: {
      namespaced: true,
      ...toast,
    },
  },
})
